import { render } from "./SavedClaimUserComponent.vue?vue&type=template&id=8a992968&scoped=true"
import script from "./SavedClaimUserComponent.vue?vue&type=script&lang=js"
export * from "./SavedClaimUserComponent.vue?vue&type=script&lang=js"

import "./SavedClaimUserComponent.vue?vue&type=style&index=0&id=8a992968&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a992968"]])

export default __exports__